import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
    language: 'english' | 'hindi';
    contentLanguage: 'english' | 'hindi';
    setLanguage: (lang: 'english' | 'hindi') => void;
    setContentLanguage: (lang: 'english' | 'hindi') => void;
}

export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            language: 'english',
            contentLanguage: 'english',
            setLanguage: (language) => set({ language }),
            setContentLanguage: (contentLanguage) => set({ contentLanguage }),
        }),
        {
            name: 'settings-storage',
        }
    )
);
